import styled from 'styled-components'

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grey24};
  margin: 13px 0px;
`

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
`

export const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`
